module.exports = __webpack_public_path__ + "img/light1.dc36fd93.png";